import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectionListComponent } from '../../../util/selectionList';
import { ModalModule } from 'ngx-bootstrap/modal';
import { EmitterService } from '../../services/emitter.service';
import { HighlightDirective } from '../../../Directives/highlight.directive';
import { clickDelayDirective } from '../../../Directives/clickDelay.directive';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { AmountFormatterDirective } from '../../../Directives/amount-formatter.directive';
// Application wide providers
const APP_PROVIDERS = [
    EmitterService
];
@NgModule({
    declarations: [
        SelectionListComponent,
        HighlightDirective,
        clickDelayDirective,
        AmountFormatterDirective
    ],
    imports: [
        CommonModule,
        SlickCarouselModule,
        ModalModule.forRoot()
    ],
    exports: [
        ModalModule,
        SelectionListComponent,
        HighlightDirective,
        clickDelayDirective,
        SlickCarouselModule,
        AmountFormatterDirective
    ]
})
export class SharedModule {
    public static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [APP_PROVIDERS]
        };
    }
}
